import { Link } from "react-router-dom";
import Button from "../Button";
import { PropsWithChildren } from "react";
import { cn } from "@/common/utils/cn";
import { ArrowUpRightIcon } from "lucide-react";

interface ButtonLinkProps {
  linkTo: string;
  operationKlassToCheckPermission?: string;
  className?: string;
  dataTestId?: string;
  hoverBackgroundSize?: "small" | "medium";
}

const ButtonLink = ({
  children,
  linkTo,
  operationKlassToCheckPermission,
  className,
  dataTestId,
  hoverBackgroundSize = "medium",
}: PropsWithChildren<ButtonLinkProps>) => {
  return (
    <Link to={linkTo} data-testid={dataTestId}>
      <Button
        variant="link-white"
        operationKlassToCheckPermission={operationKlassToCheckPermission}
        className={cn(
          "gap-1.5 transition-colors duration-100 hover:bg-white-100 p-1 -m-1 group",
          {
            "p-1 -m-1": hoverBackgroundSize === "small",
            "p-2 -m-2": hoverBackgroundSize === "medium",
          },
          className
        )}
        disabledClassName="opacity-75 cursor-default"
        noPermissionText="Você não tem permissão para acessar essa informação"
      >
        {children}

        <ArrowUpRightIcon
          size={16}
          strokeWidth={1.5}
          className="group-hover:text-blue-800"
        />
      </Button>
    </Link>
  );
}

export default ButtonLink;
